import React, { useEffect, useRef, useState } from "react";

import DownloadExcel from "../../../Extra/DownloadExcel";

const LTYearWiseData = ({ data, more }) => {
  const year1 = useRef();
  const year2 = useRef();
  const tableRef = [year1, year2];
  const tableYear = useRef();
  const [filters, setFilters] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  function filterData() {
    return data?.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        return item[key] === value;
      });
    });
  }
  useEffect(() => {
    if (Object.keys(filters).length > 0) {
      setFilteredData(filterData((data, filters)));
    } else {
      setFilteredData(data);
    }
  }, [filters, data]);

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <h4 className="bg-dark text-white p-1 ">YEAR WISE TOTAL</h4>
          <div className="table-responsive newUiBody">
            <table
              className="table  newUiTable table-hover border table-striped "
              ref={tableYear}
            >
              <thead className="table-dark">
                <tr>
                  <td> Sr</td>
                  <th>Year</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {more &&
                  more?.years?.map((year, i) => {
                    let temp = data.filter((a) => a.F_YEAR === year);
                    return (
                      <tr
                        className={
                          year === filters.F_YEAR &&
                          `border border-primary table-primary`
                        }
                        key={i}
                        style={{ cursor: "pointer" }}
                        onClick={() => setFilters({ ...filters, F_YEAR: year })}
                      >
                        <td>{i + 1}</td>
                        <td>{year}</td>
                        <td>{temp.length}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <DownloadExcel tableRef={tableYear} fileName={`AF year Wise `} />
          </div>
        </div>
      </div>
      <hr className="m-0 p-0" />
      <div className="row">
        <div className="col-md-12">
          <h4 className="bg-dark text-white p-1 ">
            Year Wise Comparison Lost Train
          </h4>
        </div>
        <div className="row">
          {more &&
            more?.years?.map((year, j) => {
              let temp = data && data.filter((a) => a.F_YEAR === year);
              let months = [...new Set(temp.map((t) => t["A_MONTH"]))];
              let Phead = [...new Set(temp.map((o) => o.detention_grp))];

              return (
                <div key={j} className="col-md-6">
                  <div className=" ">
                    <div className=" ">
                      <h4 className="text-white bg-dark"> {year}</h4>
                    </div>
                    <div className="table-responsive newUiBody">
                      <table
                        className="table newUiTable table-striped table-hover"
                        ref={tableRef[j]}
                      >
                        <thead className="table-dark">
                          <tr>
                            <th>Sr No. </th>

                            <th>Group</th>
                            <th>Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Phead.map((ah, q) => {
                            let fData = temp.filter(
                              (t) => t.detention_grp === ah,
                            );
                            return (
                              <tr
                                className={
                                  year === filters.F_YEAR &&
                                  ah === filters.detention_grp &&
                                  `border border-primary table-primary`
                                }
                                key={10 * q}
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setFilters({
                                    ...filters,
                                    F_YEAR: year,
                                    detention_grp: ah,
                                  })
                                }
                              >
                                <td>{q + 1}</td>

                                <td>{ah}</td>
                                <td>{fData.length}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <DownloadExcel
                        tableRef={tableRef[j]}
                        fileName={`AF year Wise -${year}`}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
export default LTYearWiseData;
